var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mg-message-box-content"},[_c('strong',{staticClass:"mg-message-box-content__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"mg-message-box-content__body"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }